import React from "react"

const ReviewSectionGenerator = ({ hasPhysicianOversight = false }) => {
    return (
        <div className="inline-flex h-6 justify-center items-center gap-2 content-center">
            <img className="w-5 h-5 relative bg-gray-50 rounded-full" src="/icons/check-circle-blue.svg" alt="icon"/>
            <div className="grow shrink basis-0 flex-col justify-start items-start inline-flex text-wrap">
                <div className="self-stretch text-wrap text-gray-600 text-base max-[1200px]:text-sm font-normal leading-normal">
                    {
                        <span
                            dangerouslySetInnerHTML={
                                {
                                    __html: `Physician Review section will ${hasPhysicianOversight ? "" : "<b>not</b> "}be included.`
                                }
                            }
                        />
                    }
                </div>
            </div>
        </div>
    );
}

export default ReviewSectionGenerator